angular.module('scheduler')
  .service('HistoryNotification',function ($resource,BASE_PATH) {
    return $resource(BASE_PATH.API_URL + 'installation/:installationId/notificationHistory/:id', {
      installationId: '@installationId',
      id: '@id'
    });
  });
